import React, { useEffect } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import { store } from "./store/store";
import PersistProvider from "./store/providers/persist-provider";
import "animate.css";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "./assets/scss/style.scss";
import "./assets/css/Pagination.css";
import "./i18n";
import { setproductPage } from "./store/slices/productPage-slice";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { fetchGlobalData } from "./services/GlobalApi";
import { fetchProducts } from "./services/GlobalApi";
import { fetchCategories, fetchCollectionList } from "./services/MenuApi";

const RootComponent = () => {
  useEffect(() => {
    store.dispatch(setproductPage(1));
    fetchProducts();
    fetchGlobalData();
    fetchCategories();
    fetchCollectionList()
  }, []);

  return (
    <Provider store={store}>
      <PersistProvider>
        <App />

        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </PersistProvider>
    </Provider>
  );
};

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<RootComponent />);
